import { useCallback, useContext, useEffect, useState } from 'react'


import api from 'shared/topchef-api-places';
import { NotificationType, PublicLead } from 'shared/topchef.types'

import { NotificationContext } from 'shared/NotificationContext'
import Loading from 'pages/shared/loading/Loading'
import MoreDetailsCellRenderer from "pages/shared/more-details-renderer/MoreDetailsCellRenderer"
import BriefsMarketMenu from 'pages/places/briefs-market-menu/BriefsMarketMenu';
import { useErrorBoundary } from 'react-error-boundary';
import BriefsList from 'pages/shared/briefs-list/BriefsList'
import { useOutletContext } from 'react-router';
import { PlaceOutletContextType } from '../home/PlacesHome';


const AvailableLeads = () => {

  const [loggedInPlace] = useOutletContext<PlaceOutletContextType>();
  
  const [leadsLoaded, setLeadsLoaded] = useState<boolean>(false);
  const [availableLeads, setAvailableLeads] = useState<PublicLead[]>([]);
  const [onlyMatchingLeads, setOnlyMatchingLeads] = useState<boolean>(false);
  
  const notificationContext = useContext(NotificationContext);
  const { triggerNotification } = notificationContext;

  const { showBoundary } = useErrorBoundary();

  const loadPublicLeads = useCallback( async () => {
    
    try {
      
      var leads: PublicLead[];
      if (onlyMatchingLeads) {
        leads = await api.loadAvailableLeadsMatchingMyCriteria(loggedInPlace!.id);
      } else {
        leads = await api.loadAllAvailableLeads(loggedInPlace!.id);
      }
       
      setAvailableLeads(leads);
      setLeadsLoaded(true);
    } catch (error: any) { 
      const newError = new Error(`Problème pour récupérer les briefs disponibles : '${error.message}'`);
      triggerNotification({type: NotificationType.error, message : newError.message});
      return showBoundary(newError);
    } 
  }, [onlyMatchingLeads, loggedInPlace, triggerNotification, showBoundary]);



  useEffect(() => {
    if (leadsLoaded) {
      return;
    }
    loadPublicLeads();
  }, [loadPublicLeads, leadsLoaded]);


  const moreDetailsRenderer = (params: any) => {
    const leadId: string = params.data.id;
    return (
      <MoreDetailsCellRenderer url={`/places/available-leads/${leadId}`} label={'+ de détails'}  />
    );
  };


  const reloadLeads = (event: React.ChangeEvent<HTMLInputElement>) => {
    setOnlyMatchingLeads(event.target.checked);
    setLeadsLoaded(false);
  };

  if (!leadsLoaded) {
    return (
      <Loading />
    );
  }


  return (
    <div className="page-briefs-market container p-5">
      <div id="lead_sidebar" className="d-flex">
        <ul className="nav nav-pills flex-column mb-auto">
          <li className="nav-item"> <a href="/places/share-a-lead" type="button" className="btn btn-outline-primary nav-link add-brief-link">Ajouter un brief</a></li>
        </ul>
      </div>

      <h5 className="mb-3">Briefs disponibles</h5>

      <BriefsMarketMenu loggedInPlace={loggedInPlace}/>


      <form>

        <div className="mb-3 m-0">
          <div className="form-check form-switch">
            <label className="form-check-label" htmlFor="matchingCriteriaFilter">Filtrer les briefs selon mes critères</label>
            <input className="form-check-input" type="checkbox" role="switch" id="matchingCriteriaFilter" data-testid="matchingCriteriaFilter" defaultChecked={onlyMatchingLeads} onChange={reloadLeads}/>
          </div>
        </div>

      </form>

      <BriefsList leads={availableLeads} detailsRenderer={moreDetailsRenderer} paginateResults={true} height='80%'/>

    </div>
  );


}

export default AvailableLeads;
